module.exports = __webpack_public_path__ + "static/media/films-and-stuff-vertical.84f995b7.png";